import messages from '../tag-messages.js';
export default [
    { tag: '风景', intlLabel: { defaultMessage: "风景", id: "null" } },
    { tag: '户外', intlLabel: messages.outdoors },
    { tag: '室内', intlLabel: messages.indoors },
    { tag: '界面', intlLabel: { defaultMessage: "界面", id: "null" } },
];
